import { EuiTableHeaderCell, EuiScreenReaderOnly } from "@inscopix/ideas-eui";
import { memo } from "react";
import { ProjectTablesTableColumns } from "./ProjectTablesTable";
import { ProjectTablesTableHeaderMenu } from "./ProjectTablesTableHeaderMenu";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";

export const ProjectTablesTableHeaders = memo(
  function ProjectTablesTableHeaders() {
    const sortedColumn = useProjectTablesTableContext((s) => s.sortedColumn);
    const visibleColumnsMap = useProjectTablesTableContext(
      (s) => s.visibleColumnsMap,
    );
    const onColumnSort = useProjectTablesTableContext((s) => s.onColumnSort);

    const headers = ProjectTablesTableColumns.filter(
      (column) => visibleColumnsMap[column.id],
    ).map((column) => {
      const isSortable = column.isSortable;
      const isSorted = isSortable && column.id === sortedColumn[0];
      const isAscending = isSorted && sortedColumn[1] === "ASC";

      // actions column displays the header menu
      if (column.id === "actions") {
        return (
          <EuiTableHeaderCell key={column.id} width={column.width}>
            <ProjectTablesTableHeaderMenu />
          </EuiTableHeaderCell>
        );
      }
      // don't show anything if label is hidden
      if (column.isVisuallyHiddenLabel) {
        return (
          <EuiTableHeaderCell key={column.id} width={column.width}>
            <EuiScreenReaderOnly>
              <span>{column.label}</span>
            </EuiScreenReaderOnly>
          </EuiTableHeaderCell>
        );
      }

      // render all other columns with sort state and label
      return (
        <EuiTableHeaderCell
          key={column.id}
          align={column.alignment}
          width={column.width}
          isSorted={isSorted}
          isSortAscending={isAscending}
          onSort={() => (isSortable ? onColumnSort(column.id) : undefined)}
        >
          {column.label}
        </EuiTableHeaderCell>
      );
    });
    return <>{headers}</>;
  },
);
